import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IProductos } from '../../../../private/shared/models/productos';
import { SwipeActionsComponent, SwipeActionType } from '../swipe-actions/swipe-actions.component';

@Component({
  selector: 'getm-cart-general-item',
  templateUrl: './cart-general-item.component.html',
  styleUrls: ['./cart-general-item.component.scss'],
})
export class CartGeneralItemComponent {

  @ViewChild('swipeActions') swipeActions!: SwipeActionsComponent;

  @Input() product: IProductos = {} as IProductos;
  @Input() actions: SwipeActionType[] = ['edit', 'delete'];
  @Input() isOrderActive: boolean = false;

  @Output() quantityChange = new EventEmitter<{ product: IProductos, quantity: number }>();
  @Output() editItem = new EventEmitter<IProductos>();
  @Output() removeItem = new EventEmitter<IProductos>();

  public async openOptions(): Promise<void> {
    await this.swipeActions.openOptions();
  }

  public onQuantityChange(quantity: number): void {
    this.quantityChange.emit({ product: this.product, quantity });
  }

  public onRemoveProduct(): void {
    this.removeItem.emit(this.product);
  }

  public onEditItem(): void {
    this.editItem.emit(this.product);
  }

  public onDeleteItem(): void {
    this.onRemoveProduct();
  }
}
